import { CURRENT_SEARCH_ITEMS, CLEAR_TIMELINE_SEARCH_ITEMS } from "../types"

const initialState = {
	search: {
		text: "",
		concepts: [],
		filters: {},
	},
	buildConcept: {
		text: [],
	},
	timeline: {
		text: "",
		concepts: [],
	},
	viewDocument: {
		ext_id: "",
		description: "",
	},
	axiosCancelToken: "",
}
// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case CURRENT_SEARCH_ITEMS:
			if (action.payload.page === "search") {
				return {
					...state,
					search: {
						text: action.payload.text,
						concepts: action.payload.concepts,
						filters: action.payload?.filters || {},
					},
				}
			}
			if (action.payload.page === "buildConcept") {
				return {
					...state,
					buildConcept: {
						text: action.payload.text,
						concepts: [],
					},
				}
			}
			if (action.payload.page === "timeline") {
				return {
					...state,
					timeline: {
						text: action.payload.text,
						concepts: action.payload.concepts,
					},
				}
			}

			if (action.payload.page === "viewDocument") {
				return {
					...state,
					viewDocument: { ext_id: action.payload.text, description: action.payload.concepts },
				}
			}
			if (action.payload.page === "axiosCancelToken") {
				return {
					...state,
					axiosCancelToken: action.payload.text,
				}
			}

			break

		case CLEAR_TIMELINE_SEARCH_ITEMS:
			return {
				...state,
				timeline: {
					text: "",
					concepts: [],
				},
			}

		default:
			return state
	}
}
